import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AccessControlService } from '../services/access-control.service';

/**
 * Blocks restricted admins (see {@link AccessControlService}) from reaching
 * sections outside their allow-list, redirecting them back to /users.
 * Non-restricted admins are always allowed through.
 */
@Injectable({ providedIn: 'root' })
export class RestrictedAccessGuard {
  constructor(private access: AccessControlService, private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.check(state.url);
  }

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.check(state.url);
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
    const url = '/' + segments.map(s => s.path).join('/');
    return this.access.allowedPaths$.pipe(
      take(1),
      map(allowedPaths => this.access.isAllowed(allowedPaths, url)),
    );
  }

  private check(url: string): Observable<boolean | UrlTree> {
    return this.access.allowedPaths$.pipe(
      take(1),
      map(allowedPaths => {
        if (this.access.isAllowed(allowedPaths, url)) {
          return true;
        }
        return this.router.createUrlTree(['/users']);
      }),
    );
  }
}
